import { Box, Input, makeStyles, Slider } from '@material-ui/core';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editRadius } from 'src/store/modules/imageUpload';

interface radiusProps {
  menuTitle: string;
  type: string;
  max: number;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  input: {
    width: '2rem',
    height: '1.5rem',
    marginLeft: '1rem',
    padding: 0,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    border: '1px solid #D9D9D9',
    borderRadius: '0.25rem',
    outline: 0
  }
}));

const EditRadius: any = ({ menuTitle, type, max, padding = false }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  const handleRadius = (event: any, newValue: number | number[]) => {
    const newRadius = JSON.parse(`{"${type}": ${newValue}}`);
    dispatch(editRadius({ ...radius, ...newRadius }));
  };

  const handleInputBtnRadius = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRadius = JSON.parse(
      `{"${type}": ${Number(event.target.value.replace(/[^0-9.]/g, ''))}}`
    );
    return dispatch(editRadius({ ...radius, ...newRadius }));
  };

  const handleRadiusRange = () => {
    if (radius[type] < 0) {
      const newMinBtnRadius = JSON.parse(`{"${type}": 0}`);
      dispatch(editRadius({ ...radius, ...newMinBtnRadius }));
    } else if (radius[type] > max) {
      const newMaxBtnRadius = JSON.parse(`{"${type}": ${max}}`);
      dispatch(editRadius({ ...radius, ...newMaxBtnRadius }));
    }
  };

  return (
    <div
      className={classes.root}
      style={{ paddingTop: padding ? '1.5rem' : 0 }}
    >
      <div
        style={{
          fontFamily: 'Archivo',
          fontSize: '0.875rem',
          fontWeight: 600,
          letterSpacing: '0.0175rem'
        }}
      >
        {menuTitle} RADIUS
      </div>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <Slider
          value={typeof radius[type] === 'number' ? radius[type] : 0}
          aria-labelledby="input-slider"
          onChange={handleRadius}
          max={max}
          min={0}
        />
        <input
          className={classes.input}
          type="text"
          value={radius[type]}
          onChange={handleInputBtnRadius}
          onBlur={handleRadiusRange}
        />
      </Box>
    </div>
  );
};
export default EditRadius;
